import { Moment } from 'moment';
import { QuestResponseType } from '../Quotation/Quotation.types';

export enum QuestWorkOrderSituationsFilter {
  open = 'Open',
  authorized = 'Authorized',
  closed = 'Closed',
}

export enum QuestWorkOrderTypesFilter {
  courtesy = 'domain.enums.work_order_type.courtesy',
  warranty = 'domain.enums.work_order_type.warranty',
  workOrder = 'domain.enums.work_order_type.work_order',
  totalLoss = 'domain.enums.work_order_type.total_loss',
  return = 'domain.enums.work_order_type.return',
  revision = 'domain.enums.work_order_type.revision',
}

export interface QuestCustomerWithoutMovementRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  workOrderSituationsFilter: QuestWorkOrderSituationsFilter[];
  showInactiveCustomers: boolean;
  workOrderTypesFilter: QuestWorkOrderTypesFilter[];
  startDate: string;
  endDate: string;
}

export interface QuestCustomerWithoutMovementFormValues {
  companiesIds?: number[];
  workOrderSituationsFilter: QuestWorkOrderSituationsFilter[];
  showInactiveCustomers: boolean;
  workOrderTypesFilter: QuestWorkOrderTypesFilter[];
  initialDate: Moment;
  finalDate: Moment;
}
